import { applyMiddleware, createStore as baseCreateStore, compose, Reducer, Store, AnyAction } from 'redux';
import thunk, { ThunkDispatch } from 'redux-thunk';

export const createReducer = <T = any>(
  initialState: T,
  reducerMap: Record<string, (state: T, payload?: any) => T>
): Reducer<T, AnyAction> => (state = initialState, action) => {
  const handle = reducerMap[action.type];
  
  if (typeof handle === 'function') {
    return handle(state, action.payload);
  }

  return state;
};

export const createStore = (
  reducers: Reducer<any, AnyAction>,
  state: any = {}
): Store<any, AnyAction> & { dispatch: ThunkDispatch<any, undefined, AnyAction> } => {
  // Enable Redux DevTools Extension if available
  const composeEnhancers =
    (typeof window !== 'undefined' && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
  
  const store = baseCreateStore(
    reducers,
    state,
    composeEnhancers(applyMiddleware(thunk))
  ) as Store<any, AnyAction> & { dispatch: ThunkDispatch<any, undefined, AnyAction> };
  
  // Expose store to window for debugging (only in development)
  if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
    (window as any).__REDUX_STORE__ = (window as any).__REDUX_STORE__ || {};
    // Store reference by a unique key (you can customize this)
    const storeKey = `store_${Date.now()}`;
    (window as any).__REDUX_STORE__[storeKey] = store;
    // Also keep the latest store accessible
    (window as any).__REDUX_STORE__.latest = store;
  }
  
  return store;
};
